module.exports = __webpack_public_path__ + "img/xmasParty11.e1adfb31.jpg";